import API from '../helpers/interceptor';

export const getDivisions = () =>
    API.post('/division/getdivisions', {});

export const addDivision = (data) =>
    API.post('/division/adddivision', data);

export const getDivisionHistory = (divisionCode) =>
    API.post('/division/gethistory', { divisionCode });

export const getUserDivisions = () =>
    API.post('/division/getuserdivisions', {});

export const getDivisionAdmins = (divisionCodes) =>
    API.post('/division/getdivisionadmins', { divisionCodes });
